export default __webpack_public_path__ + "static/media/pg.1b9b2da8.png";